import React from 'react';
import './DownloadImage.scss'

class DownloadImage extends React.Component {
    state = {
        isAppLoaded: false
    };

    componentDidUpdate(prevProps) {
        if (this.props.app && prevProps.app !== this.props.app) {
            this.setState({ isAppLoaded: true });
        }
    }

    downloadImage = () => {
        const { app } = this.props;
        if (!app || !app.renderer) {
            console.error("App or its renderer is not available.");
            return;
        }
        app.render();
        const imageBase64 = app.renderer.view.toDataURL("image/png");
        const a = document.createElement('a');
        a.href = imageBase64;
        a.download = 'pixi-screenshot.png';
        a.click();
    }

    render() {
        return (
            <div className='download-button'>
                <button onClick={this.downloadImage} disabled={!this.state.isAppLoaded}>
                    Download Image
                </button>
            </div>
        );
    }
}

export default DownloadImage;
